/**
 * A bad future timestamp can move TradingView's last bar ahead of the clock.
 * TradingView then ignores subsequent realtime bars as out of order.
 *
 * Keep a small allowance for clock skew between the browser and the feed.
 */
export const FUTURE_TIMESTAMP_TOLERANCE_MS = 5 * 60 * 1000

export function isFutureTimestamp(
  timestampMs: number,
  nowMs = Date.now(),
  toleranceMs = FUTURE_TIMESTAMP_TOLERANCE_MS
) {
  return Number.isFinite(timestampMs) && timestampMs > nowMs + toleranceMs
}
